export default __webpack_public_path__ + "static/media/outline-arrow-up.8b26e81c.svg";